module.exports = __webpack_public_path__ + "static/text-date-location-2690616ed6aa41653f05a086b2c714e6.png";